import React, { useState, useEffect } from "react";
import "./DeliveryFeedback.css";

const API_BASE = process.env.REACT_APP_API_URL || "https://smart-cargo-backend-923182991420.us-central1.run.app";

export default function DeliveryFeedback({ packageId, trackingCode, lang = "en" }) {
    const [phase, setPhase] = useState("loading"); // loading|form|submitting|done|already|error
    const [hovered, setHovered] = useState(0);
    const [selected, setSelected] = useState(0);
    const [errorMsg, setErrorMsg] = useState("");

    const labels = {
        en: { heading: "How was your delivery?", sub: "Your feedback helps us improve.",
            submit: "Submit Rating", already: "You've already rated this delivery.",
            thanks: "Thank you! 🎉", thanksDesc: "Your rating helps us serve you better.",
            stars: ["Terrible","Bad","Okay","Good","Excellent"], err: "Something went wrong." },
        az: { heading: "Çatdırılmanı necə qiymətləndirirsiniz?", sub: "Rəyiniz bizi inkişaf etdirir.",
            submit: "Göndər", already: "Artıq qiymətləndirdiniz.",
            thanks: "Təşəkkür edirik! 🎉", thanksDesc: "Qiymətləndirməniz xidmətimizi yaxşılaşdırır.",
            stars: ["Çox pis","Pis","Orta","Yaxşı","Əla"], err: "Xəta baş verdi." },
        ru: { heading: "Как прошла доставка?", sub: "Ваш отзыв помогает нам улучшаться.",
            submit: "Отправить", already: "Вы уже оценили эту доставку.",
            thanks: "Спасибо! 🎉", thanksDesc: "Ваша оценка помогает нам.",
            stars: ["Ужасно","Плохо","Нормально","Хорошо","Отлично"], err: "Ошибка. Попробуйте снова." },
    };
    const t = labels[lang] || labels.en;

    useEffect(() => {
        if (!packageId) return;
        fetch(`${API_BASE}/api/packages/${packageId}/feedback`)
            .then(r => r.json())
            .then(data => {
                if (data.rated) { setSelected(data.rating?.Int64 || 0); setPhase("already"); }
                else setPhase("form");
            })
            .catch(() => setPhase("form"));
    }, [packageId]);

    async function submit() {
        if (!selected) return;
        setPhase("submitting");
        try {
            const res = await fetch(`${API_BASE}/api/packages/${packageId}/feedback`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ tracking_code: String(trackingCode), rating: selected }),
            });
            if (res.ok) setPhase("done");
            else if (res.status === 409) setPhase("already");
            else { setErrorMsg(t.err); setPhase("error"); }
        } catch { setErrorMsg(t.err); setPhase("error"); }
    }

    if (phase === "loading") return null;

    if (phase === "done") return (
        <div className="dfb-card dfb-success">
            <div className="dfb-icon">🎉</div>
            <div className="dfb-title">{t.thanks}</div>
            <div className="dfb-desc">{t.thanksDesc}</div>
            <div className="dfb-stars-static">{"★".repeat(selected)}{"☆".repeat(5-selected)}</div>
        </div>
    );

    if (phase === "already") return (
        <div className="dfb-card dfb-success">
            <div className="dfb-icon">✅</div>
            <div className="dfb-desc">{t.already}</div>
            {selected > 0 && <div className="dfb-stars-static dfb-gold">{"★".repeat(selected)}{"☆".repeat(5-selected)}</div>}
        </div>
    );

    const active = hovered || selected;
    return (
        <section className="dfb-card" id="sec-feedback">
            <div className="dfb-title">{t.heading}</div>
            <div className="dfb-desc">{t.sub}</div>
            <div className="dfb-stars">
                {[1,2,3,4,5].map(s => (
                    <button key={s} type="button"
                            className={`dfb-star ${s <= active ? "dfb-star--lit" : ""}`}
                            onMouseEnter={() => setHovered(s)} onMouseLeave={() => setHovered(0)}
                            onClick={() => setSelected(s)}>★</button>
                ))}
            </div>
            {active > 0 && <div className="dfb-label">{t.stars[active-1]}</div>}
            <button type="button" onClick={submit} disabled={!selected || phase === "submitting"}
                    className={`dfb-submit ${selected ? "dfb-submit--active" : ""}`}>
                {phase === "submitting" ? "…" : t.submit}
            </button>
            {phase === "error" && <div className="dfb-error">{errorMsg}</div>}
        </section>
    );
}